import { render, staticRenderFns } from "./MstfAddO.vue?vue&type=template&id=0459444d&scoped=true&"
import script from "./MstfAddO.vue?vue&type=script&lang=js&"
export * from "./MstfAddO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0459444d",
  null
  
)

export default component.exports